import { render, staticRenderFns } from "./DashboardCallReasons.vue?vue&type=template&id=28ec6f8a&"
import script from "./DashboardCallReasons.vue?vue&type=script&lang=js&"
export * from "./DashboardCallReasons.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCallReasons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports